"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var CardSubcategorySelect_1 = __importDefault(require("../CardSubcategorySelect"));
var Select_1 = require("../../Select");
var CardSubcategorySelectContainer = function (_a) {
    var onChangeProp = _a.onChange, value = _a.value;
    var deck = core_1.useDeck();
    var subcategories = deck.subcategories;
    var subcategoryOptions = subcategories.map(function (name) { return ({
        label: name,
        value: name,
    }); });
    var _b = __read(react_1.useState(null), 2), editingOption = _b[0], setEditingOption = _b[1];
    var _c = __read(react_1.useState(''), 2), editingOptionValue = _c[0], setEditingOptionValue = _c[1];
    var onChange = react_1.useCallback(function (newValue) {
        onChangeProp(core_1.simulateChangeEvent('subcategories', newValue ? newValue.map(function (option) { return option.value; }) : []));
    }, [onChangeProp]);
    var handleCreate = react_1.useCallback(function (options) {
        onChange(options);
        var newOption = options.slice(-1)[0];
        deck.addSubcategory(newOption.value);
    }, [onChange, deck]);
    var handleClickEditOption = react_1.useCallback(function (option) {
        setEditingOption(option.value);
        setEditingOptionValue(option.value);
    }, []);
    var closeEditOptionDialog = react_1.useCallback(function () {
        setEditingOption(null);
    }, []);
    var handleDeleteOption = react_1.useCallback(function () {
        if (!editingOption)
            return;
        deck.removeSubcategory(editingOption);
        closeEditOptionDialog();
        if (value.includes(editingOption)) {
            onChange(value.filter(function (subcategory) { return subcategory !== editingOption; }));
        }
    }, [closeEditOptionDialog, value, editingOption, onChange, deck]);
    var handleChange = react_1.useCallback(function (options, event) {
        if (event.action === 'create-option') {
            handleCreate(options);
        }
        else if (event.action === 'clear') {
            onChange([]);
        }
        else {
            onChange(options);
        }
    }, [handleCreate, onChange]);
    var handleUpdateOption = react_1.useCallback(function () {
        if (editingOption === null)
            return;
        var oldName = editingOption;
        deck.renameSubcategory(oldName, editingOptionValue);
        closeEditOptionDialog();
        if (value.includes(oldName)) {
            onChange(__spreadArray(__spreadArray([], __read(value.filter(function (subcategory) { return subcategory !== oldName; }))), [
                editingOptionValue,
            ]));
        }
    }, [
        editingOption,
        onChange,
        closeEditOptionDialog,
        value,
        deck,
        editingOptionValue,
    ]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(CardSubcategorySelect_1.default, { editable: true, options: subcategoryOptions, onChange: handleChange, value: subcategoryOptions.filter(function (option) {
                return value.includes(option.value);
            }), onClickEditOption: handleClickEditOption }),
        react_1.default.createElement(Select_1.SelectEditOptionDialog, { open: !!editingOption, value: editingOptionValue, onChange: function (event) {
                return setEditingOptionValue(event.target.value);
            }, onSubmit: handleUpdateOption, onClickDelete: handleDeleteOption, onClose: closeEditOptionDialog })));
};
exports.default = CardSubcategorySelectContainer;
//# sourceMappingURL=CardSubcategorySelectContainer.js.map